import React from 'react';

// Components
import ProductImage from 'Components/commonOrder/ProductImage';
import ShipmentLotCard from 'Components/host/ShipmentLotCard';
import {T} from 'Actions/translate';
import {loadLanguage} from 'Utils/jwtUtil';
import {Checkbox} from '@material-ui/core';
import ShowShippingPlanModal from './showShippingPlanModal';
import {FROM_PAGE} from 'Utils/constant';

class ProductItem extends React.Component {
    state = {
        quantity: 0,
        inputLotNo: '',
    };

    componentWillMount() {
        const {item, orderStatus} = this.props;
        const shipQuantity =
            orderStatus === 1 ? item.tobeshippedQuantity : item.onholdQuantity;

        this.maxQuantity = 1;
        this.setState({quantity: this.maxQuantity}, () => {
            // if(util.isFunction(this.props.inputValid)) {
            //     if (item.product && item.product.inventoryDetails && item.product.inventoryDetails.length > 0) {
            //         item.product.inventoryDetails.map((detailItem, detailIndex) => {
            //             this.props.inputValid('quantity', detailItem.suggestQuantity, detailItem.id);
            //         })
            //     }
            // }
        });
    }

    getShipmentLotsInfor = (shipmentProduct) => {
        let shipmentLotsInforArr = [];
        if (shipmentProduct.kitFlag) {
            shipmentLotsInforArr = shipmentProduct.componentList;
        } else {
            shipmentLotsInforArr = shipmentProduct.inventoryDetails;
        }
        return shipmentLotsInforArr;
    };

    singleHandleCheck = (index, event) => {
        this.props.shipmentSingleHandleCheck(index, event);
    };

    inputValid = (key, value, subLotId) => {
        this.props.inputValid(key, value, subLotId);
    };

    completedShippingPlanHandle = (planId) => {
        this.props.completedShippingPlanHandle(planId);
    };

    render() {
        const {inputQuantity} = this.state;
        const {item, orderStatus, fromPage} = this.props;
        let lang = loadLanguage();
        let shipmentLotsInforArr = this.getShipmentLotsInfor(item.product);
        return (
            <li key={item.id} className="product-item">
                <div className="item-details" testid="shipment-detail-sku-item">
                    <div className="first-row-container">
                        <div className="first-column-container">
                            <div className="checkbox">
                                <Checkbox
                                    checked={item.product.checked}
                                    inputProps={{
                                        'data-testid':
                                            'shipment-product-checkbox',
                                    }}
                                    onChange={this.singleHandleCheck.bind(
                                        this,
                                        item.id,
                                    )}
                                />
                            </div>
                            <div className="image-box">
                                <ProductImage
                                    src={
                                        item.product && item.product.productPic
                                    }
                                    alt={
                                        item.product && item.product.productName
                                    }
                                />
                            </div>
                        </div>
                        <div className="item-info">
                            <div
                                className="item-name text-ellipsis"
                                testid="shipment-product-row"
                                data-sku={item.product && item.product.sku}>
                                <div
                                    className="sku-value"
                                    testid="shipment-detail-sku">
                                    {item.product && item.product.sku}
                                </div>
                                <div
                                    className="parent-specifications"
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            item.product &&
                                            item.product.specifications,
                                    }}
                                />
                            </div>
                            <div className="parent-sku">
                                <div className="storeCondition">
                                    {T('storeCondition')}:{' '}
                                    {item.product &&
                                        item.product.storeCondition}
                                </div>
                                <div className="shipping-condition">
                                    {T('fone_order_shipping_condition')}:{' '}
                                    {item.product &&
                                        item.product.shippingCondition}
                                </div>
                                {/* <div className="specifications text-ellipsis">{T('product_specifications_colon')} <span dangerouslySetInnerHTML={{ __html: item.product && item.product.specifications }}/></div> */}
                            </div>
                            {lang === 'CH' ? (
                                <div className="tobeshippedQuantity">
                                    <span className="text-ellipsis">
                                        {T('not_shippment_quantity_colon')}{' '}
                                        <label testid="shipment-pending-quantity">
                                            {orderStatus === 1
                                                ? item.tobeshippedQuantity
                                                : item.onholdQuantity}
                                        </label>
                                    </span>
                                    <span className="text-ellipsis">
                                        {T('shippment_current_inventory_colon')}{' '}
                                        <label testid="shipment-detail-current-inventory">
                                            {item.productSupplyCenter &&
                                                item.productSupplyCenter
                                                    .physicalInventory}
                                        </label>
                                    </span>
                                </div>
                            ) : (
                                <div className="tobeshippedQuantity">
                                    <span className="text-ellipsis">
                                        {T('not_shippment_quantity_colon')}{' '}
                                        <label testid="shipment-pending-quantity">
                                            {orderStatus === 1
                                                ? item.tobeshippedQuantity
                                                : item.onholdQuantity}
                                        </label>
                                    </span>
                                    <span className="text-ellipsis">
                                        {T('shippment_current_inventory_colon')}{' '}
                                        <label testid="shipment-detail-current-inventory">
                                            {item.productSupplyCenter &&
                                                item.productSupplyCenter
                                                    .physicalInventory}
                                        </label>
                                    </span>
                                </div>
                            )}
                            {/* <div className="parent-shipping-condition">
                                <div className="shipping-condition">{T('fone_order_shipping_condition')}: { item.product && item.product.shippingCondition }</div>
                            </div>  */}
                        </div>
                    </div>
                    {fromPage === FROM_PAGE.fromShipEditPage ? (
                        <ShowShippingPlanModal
                            item={item}
                            completedShippingPlanHandle={
                                this.completedShippingPlanHandle
                            }
                        />
                    ) : null}
                    {shipmentLotsInforArr &&
                        shipmentLotsInforArr.length > 0 && (
                            <ShipmentLotCard
                                parentSku={item.product.sku}
                                shipmentLots={shipmentLotsInforArr}
                                kitFlag={item.product.kitFlag}
                                inputValid={this.inputValid}></ShipmentLotCard>
                        )}
                </div>
            </li>
        );
    }
}

export default ProductItem;
